// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__3U3ai","icon--clickable":"style_icon--clickable__VqIMo"};